// src/components/CapoOfficina/CapoOfficinaDashboard.jsx
import React, { useState } from 'react';
import CapoOfficinaWorkHours from './CapoOfficinaWorkHours';
import CapoOfficinaTimekeeping from './CapoOfficinaTimekeeping';
import CapoOfficinaWorkerRequests from './CapoOfficinaWorkerRequests';
import CapoOfficinaMezzi from './CapoOfficinaMezzi';
import CapoOfficinaRapportini from './CapoOfficinaRapportini';
import './capoofficina.css';

const CapoOfficinaDashboard = () => {
  const [activeTab, setActiveTab] = useState('hours');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'hours':
        return <CapoOfficinaWorkHours />;
      case 'timekeeping':
        return <CapoOfficinaTimekeeping />;
      case 'requests':
        return <CapoOfficinaWorkerRequests />;
      case 'mezzi':
        return <CapoOfficinaMezzi />;
      case 'rapportini':
        return <CapoOfficinaRapportini />;
      default:
        return <CapoOfficinaWorkHours />;
    }
  };

  return (
    <div className="admin-panel">
      {/* Header centrale simile alla dashboard responsabile */}
      <div style={{
        textAlign: 'center',
        padding: '40px 20px',
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
        marginBottom: '30px',
        border: '1px solid #e9ecef'
      }}>
        <h2 style={{
          margin: '0 0 15px 0',
          fontSize: '2.2rem',
          color: '#6c757d',
          fontWeight: '700',
          textShadow: '0 2px 8px rgba(108, 117, 125, 0.2)'
        }}>
          🔧 Pannello Fleet Coordinator
        </h2>
        <p style={{
          margin: 0,
          color: '#6c757d',
          fontSize: '1.1rem',
          fontWeight: '500'
        }}>
          Gestisci il parco mezzi e le manutenzioni
        </p>
      </div>

      {/* Tab navigation - stesso stile del responsabile */}
      <div className="admin-tabs">
        <button 
          className={`tab-button ${activeTab === 'hours' ? 'active' : ''}`}
          onClick={() => setActiveTab('hours')}
          style={{
            '--primary': '#6c757d'
          }}
        >
          📊 Gestione Ore
        </button>
        
        <button 
          className={`tab-button ${activeTab === 'timekeeping' ? 'active' : ''}`}
          onClick={() => setActiveTab('timekeeping')}
          style={{
            '--primary': '#6c757d'
          }}
        >
          ⏰ Timbrature
        </button>
        
        <button 
          className={`tab-button ${activeTab === 'requests' ? 'active' : ''}`}
          onClick={() => setActiveTab('requests')}
          style={{
            '--primary': '#6c757d'
          }}
        >
          📝 Richieste
        </button>
        
        <button 
          className={`tab-button ${activeTab === 'mezzi' ? 'active' : ''}`}
          onClick={() => setActiveTab('mezzi')}
          style={{
            '--primary': '#6c757d'
          }}
        >
          🚛 Mezzi
        </button>
        
        <button 
          className={`tab-button ${activeTab === 'rapportini' ? 'active' : ''}`}
          onClick={() => setActiveTab('rapportini')}
          style={{
            '--primary': '#6c757d'
          }}
        >
          📋 Rapportini Officina
        </button>
      </div>

      {/* Contenuto della tab attiva */}
      <div className="admin-content">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default CapoOfficinaDashboard;